export const OtherSystemKeys = {
  lightOn: 'lightOn',
  halfLight: 'halfLight',
  emergencyLight: 'emergencyLight',
  eventRecorderSourcedEmergency: 'eventRecorderSourcedEmergency',
  ccuMemoryError: 'ccuMemoryError',
  tkysCommunicationError: 'tkysCommunicationError',
  wtbCommunicationError: 'wtbCommunicationError',
  fireSystemAlarm: 'fireSystemAlarm',
  fireExtinguisher1Presence: 'fireExtinguisher1Presence',
  fireExtinguisher2Presence: 'fireExtinguisher2Presence',
  fireExtinguisher3CabinPresence: 'fireExtinguisher3CabinPresence',
  handle1PassengerAlarm: 'handle1PassengerAlarm',
  handle2PassengerAlarm: 'handle2PassengerAlarm',
  handle3PassengerAlarm: 'handle3PassengerAlarm',
  handle4PassengerAlarm: 'handle4PassengerAlarm',
  toiletOutOfOrderSignal: 'toiletOutOfOrderSignal',
  wcSosSignal: 'wcSosSignal',
  toiletActive: 'toiletActive',
  contactor1DegradedModeInserted: 'contactor1DegradedModeInserted',
  contactor2DegradedModeInserted: 'contactor2DegradedModeInserted',
  sandLevelSensor1Bogie1Axle1: 'sandLevelSensor1Bogie1Axle1',
  sandLevelSensor2Bogie1Axle1: 'sandLevelSensor2Bogie1Axle1',
  sandLevelSensor3Bogie2Axle3: 'sandLevelSensor3Bogie2Axle3',
  sandLevelSensor4Bogie2Axle3: 'sandLevelSensor4Bogie2Axle3',
  sandLevelSensor5Bogie2Axle4: 'sandLevelSensor5Bogie2Axle4',
  sandLevelSensor6Bogie2Axle4: 'sandLevelSensor6Bogie2Axle4',
  inhibitionPassengerAlarmActive: 'inhibitionPassengerAlarmActive',
  passengersAlarm: 'passengersAlarm',
  levelWashWaterTank: 'levelWashWaterTank',
  tailLightRedLeft: 'tailLightRedLeft',
  tailLightRedRight: 'tailLightRedRight',
  dimmedMarkerLightLeftRight: 'dimmedMarkerLightLeftRight',
  dimmedHeadLightLeft: 'dimmedHeadLightLeft',
  dimmedHeadLightRight: 'dimmedHeadLightRight',
  fullMarkerLightLeftRight: 'fullMarkerLightLeftRight',
  fullHeadLightLeftRight: 'fullHeadLightLeftRight',
  deadManControl: 'deadManControl',
  deadManByPass: 'deadManByPass',
  toiletVacuumFailure: 'toiletVacuumFailure',
  toiletPressureFailure: 'toiletPressureFailure',
  toiletCommunicationError: 'toiletCommunicationError',
  waterLevelLow: 'waterLevelLow',
  wasteWaterTankFull: 'wasteWaterTankFull',
  toiletBowlFull: 'toiletBowlFull',
  toiletSystemAirPressureLow: 'toiletSystemAirPressureLow',
  eventRecorderError: 'eventRecorderError',
  fireSystemFault: 'fireSystemFault',
  fduMinorFault: 'fduMinorFault',
  fduMajorFault: 'fduMajorFault',
  fduSevereFault: 'fduSevereFault',
  deadManFault: 'deadManFault',
  functionOk: 'functionOk',
  outdoorLightingAutomaticControl: 'outdoorLightingAutomaticControl'
} as const;
